<template>
    <div class="detailBox">
        <div class="detailBack">
           <div class="detailBack_auto">
               <div class="detaillleftback"></div>
               <div class="detailBack_">
                    <div :class="['detailBack_logo'+detailid]"></div>
                    <h3>{{name}}</h3>
                    <p>{{text}}</p>
                    <div class="detailBack_back" v-if="detailid==0"></div>
                    <div class="detailBack_back1" v-if="detailid==1"></div>
                    <div class="detailBack_back2" v-if="detailid==2"></div>
                    <div class="detailBack_back3" v-if="detailid==3"></div>
                </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['name','text','detailid'],
}
</script>
<style scoped>
.detailBox{
  margin-top: 66px;

}
.detailBack{
  width: 100%;
  height: 320px;
  background: #1D2337;
  padding-top: 58px;
  box-sizing: border-box;
  position: relative;

}
.detailBack_auto{
    width: 1126px;
    height: 100%;
    margin: 0px auto;
    position: relative;
}
.detaillleftback{
    width: 107px;
    height: 164px;
    background: linear-gradient(180deg, rgba(29, 35, 55, 0) 0%, #1D2337 100%);
    position: absolute;
    left: -48px;
    bottom: 0px;
    background: url(../../static/images/detailleftback.png) no-repeat center center;
    background-size: contain;
}
.detailBack_back{
    width: 506px;
    height: 320px;
    background: url(../../static/images/wsbxright.png) no-repeat center center;
    background-size: contain;
    position: absolute;
    right: 0;
    top: -58px;
}
.detailBack_back1{
    width: 309px;
    height: 273px;
    background: url(../../static/images/xsdcright.png) no-repeat center center;
    background-size: contain;
    position: absolute;
    right: 0;
    top: -58px;

}
.detailBack_back2{
    width: 309px;
    height: 273px;
    background: url(../../static/images/wyfwright.png) no-repeat center center;
    background-size: contain;
    position: absolute;
    right: 0;
    top: -58px;
}
.detailBack_back3{
    width: 309px;
    height: 273px;
    background: url(../../static/images/jxjlright.png) no-repeat center center;
    background-size: contain;
    position: absolute;
    right: 0;
    top: -58px;
}
.detailBack_{
    width: 1126px;
    height: 158px;
    margin: 0px auto;
    position: relative;
    padding-left: 11px;
    box-sizing: border-box;
}
.detailBack_>h3{
  width: 100%;
  height: 28px;
  font-size: 20px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 20px;
}
.detailBack_>p{
  width: 641px;
  height: 40px;
  font-size: 14px;
  font-weight: 400;
  color: #BAC1C9;
  line-height: 20px;

}
.detailBack_logo0{
    width: 122px;
    height: 36px;
    background: url(../../static/images/wsbx1logo.png) no-repeat center center;
    background-size: contain;
    margin-bottom: 26px;
}
.detailBack_logo1{
    width: 240px;
    height: 36px;
    background: url(../../static/images/xsdclogo.png) no-repeat center center;
    background-size: contain;
    margin-bottom: 26px;
}
.detailBack_logo2{
    width: 219px;
    height: 36px;
    background: url(../../static/images/wyfwlogo.png) no-repeat center center;
    background-size: contain;
    margin-bottom: 26px;
}
.detailBack_logo3{
    width: 220px;
    height: 36px;
    background: url(../../static/images/jxjllogo.png) no-repeat center center;
    background-size: contain;
    margin-bottom: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/detailTop.vue